// Vendor packages
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as Scroll from 'react-scroll'

const Scrollable = Scroll.Element

// Component definition
export default function withAnchor(WrappedComponent) {
  class Anchorable extends React.Component {
    render() {
      return this.props.isTarget ? (
        <Scrollable name={this.props.entryId}>
          <WrappedComponent {...this.props} />
        </Scrollable>
      ) : (
        <WrappedComponent {...this.props} />
      )
    }
  }

  Anchorable.propTypes = {
    isTarget: PropTypes.bool
  }

  const mapStateToProps = ({ page }, ownProps) => {
    return {
      isTarget: page.anchors && page.anchors.includes(ownProps.entryId)
    }
  }

  return connect(mapStateToProps, null)(Anchorable)
}
